(() => {
  'use strict';
  // Keep ARIS's preview input unchanged so its renderer can update/remove it.
  // Only the submitted property becomes private; retain the original File.
  document.addEventListener('formdata', event => {
    const data = event.formData;
    for (const key of Array.from(data.keys())) {
      if (!/^(?:items\[\d+\]\[properties\]|properties)\[live_preview\]$/.test(key)) continue;
      const privateKey = key.replace('[live_preview]', '[_live_preview]');
      const values = data.getAll(key);
      data.delete(key);
      data.delete(privateKey);
      for (const value of values) data.append(privateKey, value);
    }
  }, true);
})();
